import CustomScrollbar from 'app/components/CustomScrollbar';
import { SecondaryIndicationSelector } from 'app/components/IndicationSelector';
import { useNavigate, useParams } from 'react-router-dom';

import Header from '../../../components/Header';
import Spinner from '../../../components/Spinner';
import { Heading1 } from '../../../components/Typography';
import useFetchCategoryResults from '../../../hooks/fetch/useFetchCategoryResults';
import useFooterLinks from '../../../hooks/useFooterLinks';
import TailorLooking from '../components/TailorLooking';
import TailorSearchResults from '../components/TailorSearchResults';
import useHandleSearchResultClick from '../hooks/useHandleSearchResultClick';

export default function TailorCategory() {
  const params = useParams();
  const navigate = useNavigate();
  const category = decodeURIComponent(params.category || '');

  const { data, isLoading } = useFetchCategoryResults(category);

  const handleResultSelect = useHandleSearchResultClick();
  const { secondaryFooterLink } = useFooterLinks();

  const handleBackButtonClick = () => {
    navigate('/tailor', { state: { isBack: true } });
  };

  return (
    <CustomScrollbar
      id="ostro-tailor-category-container"
      className="flex flex-col grow relative"
      rememberScrollPosition
    >
      <div className="grow flex flex-col px-7 py-5">
        <Header
          showBackButton
          showSearchButton
          onClickBack={handleBackButtonClick}
        />
        <Heading1 className="mt-8">
          <span dangerouslySetInnerHTML={{ __html: category }} />
        </Heading1>
        {isLoading ? (
          <div className="grow flex justify-center mt-24">
            <Spinner />
          </div>
        ) : null}

        {!isLoading && (
          <TailorSearchResults
            className="border-typography-divider border-t mt-6 border-t-[0.4px]"
            results={data}
            onSelectResult={(result, index) =>
              handleResultSelect({
                result,
                resultIndex: index + 1,
                isSuggested: false,
                categoryTitle: category,
                linkLocation: 'topicCategoryPage',
              })
            }
          />
        )}
      </div>
      <SecondaryIndicationSelector className="px-7 pb-5 grow" />
      <TailorLooking footerLink={secondaryFooterLink} />
    </CustomScrollbar>
  );
}
